import "./Dashboard.html";

import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";

export class DashboardComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {};
        this.templateUrl = "/App/Components/Dashboard/Dashboard.html";
    }
}

module("mmManagePortal").component("mmDashboard", new DashboardComponent());
